import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import includes from "lodash/includes";
import CrmContacts from "./CrmContacts";
import CrmToolbar from "./CrmToolbar";
import operations from "./ducks/operations";
import actions from "./ducks/actions";

const CrmContactsContainer = (props) => {
    const { auth, flushContactsState, getContactsForUser, match } = props;

    useEffect(() => {
        const { id } = match.params;
        getContactsForUser(id);
        ReactGA.send({ hitType: "pageview", page: "/contacts", title: "Contacts" });
        return () => {
            flushContactsState();
        };
    }, []);

    return (
        includes(
            [
                "broker",
                "portlandBrokerAdmin",
                "arizonaBrokerAdmin",
                "propertyManagement",
                "debtEquity",
                "appraiser",
                "general",
                "officeManager",
                "research",
                "researchAdmin",
                "evp",
                "transition",
                "accounting",
                "dataEntry",
                "dataAdmin",
            ],
            auth.userProfile.role
        ) && (
            <React.Fragment>
                <CrmToolbar {...props} />
                <CrmContacts {...props} />
            </React.Fragment>
        )
    );
};

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer,
        contacts: state.crmReducer.contacts,
        elementsSaving: state.utilsReducer.elementsSaving,
        columnToSort: state.crmReducer.columnToSort,
        sortDirection: state.crmReducer.sortDirection,
        filterQuery: state.crmReducer.filterQuery,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleSort: (column) => {
            dispatch(operations.sort(column));
        },
        handleFilter: (query) => {
            dispatch(operations.filter(query));
        },
        getContactsForUser: (user) => {
            dispatch(operations.getContactsForUser(user));
        },
        deleteContact: (contactId, index) => {
            dispatch(operations.deleteContact(contactId, index));
        },
        flushContactsState: () => {
            dispatch(actions.handleInput("contacts", []));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CrmContactsContainer);
